import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";  
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
// import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import { history } from "../../../history/history";
import moment from "moment";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from "react-js-pagination";


const User = (props) => {
  //Set the initial state
  const [user, handleUser] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [limit, handleLimit] = useState(10);
  const [searchName, handleSearchName] = useState(undefined);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  const [selectedMentees, handleSelectedMentees] = useState(undefined);
  const [selectedActiveContacts, handleSelectedActiveContacts] = useState(undefined);
  const [selectedRole, handleSelectedRole] = useState(undefined);
  const [selectedCluster, handleSelectedCluster] = useState(undefined);
  const [clusterData, handleClusterData] = useState([]);
  const [activePage, handleActivePage] = useState(1);
  const [totalRecords, handleTotalRecords] = useState(0);
  

  let rolesList = [
    { role: "", name: "Choose Role" },
    { role: "dsa", name: "Trade Partner" },
    { role: "auditAdmin,stationAdmin,trafficAdmin,clusterAdmin,admin,salesUser", name: "Employee" },
  ];

  // let clusterData = [];

  useEffect(() => {
    getClusterData();
  }, []);

  useEffect(() => {
    getUser(0);
  }, [selectedCluster, selectedRole])

  //Fetching the users
  const getUser = async (skip, limitCount) => {
    handleSkip(skip);
    var adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
    let param = {
      cluster: adminInfo.cluster,
      station: adminInfo.station,
      skip: skip,
      limit: (limitCount ? limitCount : limit)
    };

    if(selectedRole){
      param.selectedRole = selectedRole;
    }

    if( selectedCluster ){
      param.selectedCluster = selectedCluster;
    }
    
    try {
      const data = await Axios.get(endPoints.getSalesUserPerformance, {
        params: param,
      });
      const result = data.data.data.data;
      if (result) {
        handleUser(result);
        handleCount(data.data.data.count);
        handleTotalRecords(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
      // handleRodp([])
    }
  };

  const handlePageChange= (page) => {
    let skipCount = limit * (page-1);
    handleActivePage(page);
    handleSkip(skipCount);
    getUser(skipCount);
  }
  const goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //Searching the user
  const getSearch = (e) => {
    getUser(0, e.target.value);
  };

  const showMentees = (e) => {
    let salesUserKey = e.target.getAttribute("data-key-id");
    let mentees = user[salesUserKey].mentees;

    if(mentees.length) handleSelectedMentees(mentees);
    
  };

  const showActiveContacts = (e) => {
    let salesUserKey = e.target.getAttribute("data-key-id");
    let regionActiveContacts = user[salesUserKey].regionActiveContacts;
    if(user[salesUserKey].regionActiveContacts.length) handleSelectedActiveContacts(regionActiveContacts);
  };
  

  const getClusterData = async () => {
    try {
      const response = await Axios.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result
        .map((e) => {
          return e.name;
        })
        .sort();
      if (result) {
        // clusterData = result;
        handleClusterData(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const changeLimit = (e) => {
    let selectedValue = e.target.value;
    if(selectedValue == 'All'){
      selectedValue = 100000;
      handleLimit(100000);
    }else{
      handleLimit(selectedValue);
    }
    getUser(skip, selectedValue);
  }
  
  return (
    <div className="dashboardContainer">
       <HeaderAdminpanel/>

      {/* <div className="navbar-header dashboard-header clearfix">
        <div className="logo-dashboard">
          <a id="logo">
            <img className="logo-trans" src="/assets/images/new_logo.png" />
          </a>
          <span>Welcome: {adminData.email} </span>
          <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
        </div>
        <div
          className="user-profile pull-right"
          tabIndex={0}
          onClick={() => {
            localStorage.removeItem("adminInfo");
            window.location.href = "/admin/login";
          }}
        >
          <a>
            <span>
              LOGOUT
              <span className="log_img">
                <img src="/assets/images/ic_logout.png" />
              </span>
            </span>
          </a>
        </div>
      </div> */}
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar role={localStorage.getItem("adminRole")} />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Sales User | <span className="breadcrumb-active fct-breadcrumb"> Performance </span>

              { selectedMentees && (
                <span className="print_btn mrgLft10px">
                  <button className="mrgLft10px"
                    onClick={(e) => {
                      handleSelectedMentees(undefined);
                    }}
                  >
                    {" "}
                    Show User Performance{" "}
                  </button>{" "}
                </span>
              ) }
              { selectedActiveContacts && (
                <span className="print_btn mrgLft10px">
                  <button className="mrgLft10px"
                    onClick={(e) => {
                      handleSelectedActiveContacts(undefined);
                    }}
                  >
                    {" "}
                    Show User Performance{" "}
                  </button>{" "}
                </span>
              ) }
            </div>

            <div className="dashboard-breadcrumb dashboard-breadcrumb status-input ">
              <div style={{display: "flex"}}>
                <span style={{ fontSize: "16px", width: "100px", marginRight: "20px", display: "flex", alignItems: "center" }}>Filter</span>
                <select
                  className="packageType drop-down-icon status-dropdown"
                  onChange={(e) =>
                    handleSelectedRole(e.target.value)
                  }
                >
                  {rolesList.map((role, index) => (
                    <option key={index} value={role.role}>
                      {role.name}
                    </option>
                  ))}
                </select>

                <select
                  className="packageType drop-down-icon status-dropdown"
                  onChange={(e) => {
                    handleSelectedCluster(e.target.value)
                  }}
                >
                  <option value="">
                    Choose ClusterName{" "}
                  </option>{" "}
                  {clusterData.map((cluster) => (
                    <option value={cluster}> {cluster} </option>
                  ))}{" "}
                </select>{" "}
              </div>
            </div>
            {/* <div className={!searchName && user.length === 0 ? "search_camp none" : "search_camp"}>
              <input type="text" placeholder="search" onChange={getSearch} />
              <span>
                <img src="/assets/images/search.png" />
              </span>
            </div> */}
          </div>
          
          
          <div
            className={
              user.length === 0
                ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                : "dashboard-content userListing-dashboard bg-white table-responsive"
            }
          >
            <div className="print_btn mrgLft10px" style={{ display: "flex", justifyContent: "space-between", margin: "7px", alignItems: "center"}}>
              <div style={{ display: "flex", width: "200px", alignItems: "center"}}>
                Show&nbsp;
                <select className="packageType drop-down-icon status-dropdown" onChange={ changeLimit }>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="All">All</option>
                </select>
                &nbsp;entries
              </div>
              
              {/* Show this only if the primary performance table is show in the screen */}
              { !selectedMentees && !selectedActiveContacts && (
                
                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="download-table-xls-button"
                  table="performance-table"
                  filename="sales-user-performance"
                  sheet="performance"
                  buttonText="Export" />
              )}
            </div>
            
            { !selectedMentees && !selectedActiveContacts && (
              <div>
                <table className="table table-striped master-table" id="performance-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th style={{textAlign: "center"}} colSpan="3">Session Time (Hours:Minutes)</th>
                      <th style={{textAlign: "center"}} colSpan="3">Campaigns</th>
                      <th style={{textAlign: "center"}} colSpan="3">Interactions</th>
                    </tr>
                    <tr>
                      <th style={{maxWidth: "125px"}}>Name</th>
                      <th>Email</th>
                      <th>Cluster/ Station</th>
                      <th>Trade Partner</th>
                      <th>Active Contact in Region</th>
                      <th>Last Login</th>
                      <th> { moment().format("MMMM YYYY")} </th>
                      <th> { moment().subtract(1,'months').format("MMMM YYYY")} </th>
                      <th> { moment().subtract(2,'months').format("MMMM YYYY")} </th>
                      <th> { moment().format("MMMM YYYY")} </th>
                      <th> { moment().subtract(1,'months').format("MMMM YYYY")} </th>
                      <th> { moment().subtract(2,'months').format("MMMM YYYY")} </th>
                      <th> { moment().format("MMMM YYYY")} </th>
                      <th> { moment().subtract(1,'months').format("MMMM YYYY")} </th>
                      <th> { moment().subtract(2,'months').format("MMMM YYYY")} </th>
                    </tr>
                  </thead>
                  <tbody>
                    { user.map((r, index) => {
                      return (
                        <tr key={index}>
                          <td style={{maxWidth: "125px"}}>{r.name || '--'}</td>
                          <td title={r.email} style={{overflow: "hidden", textOverflow: "ellipsis"}}>{r.email}</td>
                          <td>{r.cluster || r.station || '--'}</td>
                          <td> <span style={{cursor: "pointer"}} data-key-id={index} onClick={showMentees}>{r.mentees.length || '0'}</span></td>
                          <td> <span style={{cursor: "pointer"}} data-key-id={index} onClick={showActiveContacts}>{r.regionActiveContacts.length || '0'}</span></td>
                          <td>{r.lastLogin && <span>{moment(r.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>} {!r.lastLogin && <span>NA</span>} </td>
                          <td>{Math.floor(moment.duration(r.thisMonth).asHours())}:{ moment.utc(r.thisMonth).format("mm") }</td>
                          <td>{Math.floor(moment.duration(r.lastOneMonth).asHours())}:{ moment.utc(r.lastOneMonth).format("mm") }</td>
                          <td>{Math.floor(moment.duration(r.lastTwoMonth).asHours())}:{ moment.utc(r.lastTwoMonth).format("mm") }</td>
                          <td>{r.thisMonthCampaign}</td>
                          <td>{r.lastOneMonthCampaign}</td>
                          <td>{r.lastTwoMonthCampaign}</td>
                          <td>{r.thisMonthInteractions}</td>
                          <td>{r.lastOneMonthInteractions}</td>
                          <td>{r.lastTwoMonthInteractions}</td>
                        </tr>)
                      
                    })}
                  </tbody>
                </table>
                {(skip > 0 || count >= 10) && (
                <div className="paginationTable">
                  {/* <Pagination getAllData={getUser} totalRecords={count} /> */}
                  <div className="pagination-wrapper">
                    <div className="dataTables_paginate paging_full_numbers" id="advertiser-details_paginate">
                      <Pagination
                        prevPageText='Prev'
                        nextPageText='Next'
                        firstPageText='First'
                        lastPageText='Last'
                        activePage={activePage}
                        itemsCountPerPage={limit}
                        totalItemsCount={totalRecords}
                        onChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>)}
              </div>
            )}
            { selectedMentees && (
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Cluster/Station</th>
                    <th>Last Login</th>
                    <th>Last Active Session</th>
                  </tr>
                </thead>
                <tbody>
                  { selectedMentees.map((mentee, mIndex) => (
                    <tr key={mIndex}>
                      <td>{ mentee.name }</td>
                      <td>{ mentee.email }</td>
                      <td>{ mentee.cluster || mentee.station || '--' }</td>
                      <td>{mentee.lastLogin && <span>{moment(mentee.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>}
                              {!mentee.lastLogin && <span>NA</span>}
                          </td>
                      <td>{ mentee.lastActiveSession ? (<span>{moment(mentee.lastActiveSession).format("DD/MM/YYYY hh:mm A")}</span>) : (<span>NA</span>) } </td>
                    </tr>
                  ))}
                </tbody>
              </table>  
            )}
            { selectedActiveContacts && (
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Name</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Message</th>
                    <th>Last Update</th>
                    <th>Interactions</th>
                    <th>Company</th>
                    <th>Email</th>
                    <th>Mobile</th>
                  </tr>
                </thead>
                <tbody>
                  { selectedActiveContacts.map((contact, cIndex) => (
                    <tr key={cIndex}>
                      <td>{ moment(contact.createdAt).format("DD/MM/YYYY HH:mm:A") }</td>
                      <td>{ contact.name }</td>
                      <td>{ contact.state }</td>
                      <td>{ contact.city }</td>
                      <td>{ contact.message }</td>
                      <td>{ contact.remarks.length > 0 && moment(contact.remarks[0].date).format( "DD/MM/YYYY hh:mm:A" )}</td>
                      <td>{ contact.remarks.length }</td>
                      <td>{ contact.company } </td>
                      <td>{ contact.email } </td>
                      <td>{ contact.mobile } </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {user.length === 0 ? <NoData /> : null}
        </section>
      </div>
    </div>
  );
};

export default connect(null, {})(User);



// WEBPACK FOOTER //
// ./web/components/admin/userManagement/salesUserPerformance.js